module.exports = __webpack_public_path__ + "img/SAPIENCIA_LOGO.7b39a67d.svg";